import {JKUserDetail} from 'components/Backend/JKUser/Detail';

export default JKUserDetail;
